import { oc } from '@orpc/contract';
import { contactSchema, updateContactInputSchema } from '../schemas/contacts.schemas.js';
/** PATCH semantics: an absent field is left alone. */
export const updateContactContract = oc
    .route({
    method: 'POST',
    path: '/contacts/{contactId}',
    tags: ['Contacts'],
    summary: 'Update a contact',
})
    .input(updateContactInputSchema)
    .output(contactSchema);
//# sourceMappingURL=update-contact.contract.js.map